import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Dashboard from '../../components/Dashboard/Dashboard';
import { setMainSearchParams } from '../../store/actions/actions';
import { getSearchParams } from '../../helpers/searchParamsFns';
import RequestsLineChart from '../../components/RequestsLineChart/RequestsLineChart';
import styles from './Main.module.scss';

const Main = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    const searchParams = getSearchParams(location.search);

    return () => dispatch(setMainSearchParams(searchParams));
  }, [dispatch, location.search]);

  return (
    <div className={styles.root}>
      <div className={styles['mb-25']}>
        <Dashboard />
      </div>
      <RequestsLineChart />
    </div>
  );
};

export default Main;
